var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import IconContainer, { IconSVG } from './IconContainer';
var IconTableMinusRow = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", strokeLinejoin: "round", strokeLinecap: "round" },
            React.createElement("g", null,
                React.createElement("line", { strokeWidth: "1", x1: "3.5", y1: "21.5", x2: "10.5", y2: "21.5" }),
                React.createElement("line", { strokeWidth: "1", x1: "3.5", y1: "11.5", x2: "26.5", y2: "11.5" }),
                React.createElement("line", { strokeWidth: "1", x1: "3.5", y1: "16.5", x2: "10.5", y2: "16.5" }),
                React.createElement("line", { strokeWidth: "1", x1: "10.5", y1: "11.5", x2: "10.5", y2: "26.5" }),
                React.createElement("line", { strokeWidth: "1", x1: "6.2", y1: "7.5", x2: "18.2", y2: "7.5" }),
                React.createElement("path", { strokeWidth: "1", d: "M27,14.5V4.7C27,3.2,26.8,3,25.3,3H4.7C3.2,3,3,3.2,3,4.7v20.6C3,26.8,3.2,27,4.7,27h7.5" })),
            React.createElement("path", { strokeWidth: "2", d: "M15.5,21.7H28" }))));
});
export default IconTableMinusRow;
//# sourceMappingURL=IconTableMinusRow.js.map